import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../utils/api';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); return; }
    api.get('/auth/verify-email?token=' + token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [params]);

  return (
    <div className="min-h-screen bg-tea-50 flex items-center justify-center">
      <div className="card max-w-md w-full text-center py-12">
        {status === 'verifying' && (
          <>
            <div className="text-5xl mb-4">⏳</div>
            <p className="text-gray-600">Verifying your email...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-5xl mb-4">✅</div>
            <h1 className="text-2xl font-bold mb-2">Email Verified!</h1>
            <p className="text-gray-600 mb-6">Your account is confirmed. You can now sign in.</p>
            <Link to="/login" className="btn-primary inline-block">Sign In</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-5xl mb-4">❌</div>
            <h1 className="text-2xl font-bold mb-2">Invalid Token</h1>
            <p className="text-gray-600 mb-6">This link may have expired or already been used.</p>
            <Link to="/register" className="btn-secondary inline-block">Register Again</Link>
          </>
        )}
      </div>
    </div>
  );
}
